import { graphql } from "@/generated";
import { useMutation } from "@urql/vue";
import { toValue, watch, type MaybeRefOrGetter } from "vue";

const EnteredChannelDocument = graphql(/* GraphQL */ `
  mutation EnteredChannel($channel_id: String!) {
    enteredChannel(channel_id: $channel_id)
  }
`);

export function useChannelVisitTracking(
  channelId: MaybeRefOrGetter<string | null | undefined>,
) {
  const submittedChannelIds = new Set<string>();
  const { executeMutation } = useMutation(EnteredChannelDocument);

  watch(
    () => toValue(channelId),
    (resolvedChannelId) => {
      if (!resolvedChannelId || submittedChannelIds.has(resolvedChannelId)) {
        return;
      }

      submittedChannelIds.add(resolvedChannelId);
      void executeMutation({ channel_id: resolvedChannelId });
    },
    { immediate: true },
  );
}
